<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>{{ 'activity-stream.activity-stream' | translate }}</h3>
    </div>
    <div class="inner-content">
      <coin-c-activity-stream
        [loadConfig]="data.loadConfig"
        [type]="data.type"
        [reload$]="reload$"></coin-c-activity-stream>
    </div>
  </div>
  <coin-v2-dialog-footer
    padding="large"
    color="white">
    <coin-v2-button
      [type]="'secondary'"
      [icon]="'close'"
      [iconPos]="'right'"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
  </coin-v2-dialog-footer>
</div>
